/* ========================================================================
   zy-collection.js — Phase 2
   ======================================================================== */
(function () {
  var root = document.querySelector('[data-zy-collection]');
  if (!root) return;

  /* --- Sort --- */
  var sortSelect = root.querySelector('[data-zy-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* --- Filter drawer (mobile only — on desktop the panel is always
     visible via CSS, see .zy-layout--has-filters in zy-collection.css) --- */
  var panel = root.querySelector('[data-zy-filter-panel]');
  var toggleBtn = root.querySelector('[data-zy-filter-toggle]');
  var closeBtn = root.querySelector('[data-zy-filter-close]');
  var lastFocused = null;

  function syncPanelAccessibility() {
    if (!panel) return;
    var desktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    var open = panel.dataset.open === 'true';
    var available = desktop || open;
    panel.inert = !available;
    panel.setAttribute('aria-hidden', available ? 'false' : 'true');
  }

  function openPanel() {
    if (!panel) return;
    lastFocused = document.activeElement;
    panel.dataset.open = 'true';
    syncPanelAccessibility();
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
    var first = panel.querySelector('input, button, a');
    if (first) first.focus();
  }
  function closePanel() {
    if (!panel) return;
    panel.dataset.open = 'false';
    syncPanelAccessibility();
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused) lastFocused.focus();
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key === 'Tab' && panel) {
      var focusables = panel.querySelectorAll('input, button, a, select');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  }
  toggleBtn && toggleBtn.addEventListener('click', openPanel);
  closeBtn && closeBtn.addEventListener('click', closePanel);
  syncPanelAccessibility();
  window.addEventListener('resize', syncPanelAccessibility);

  /* --- Filter form: auto-apply on change (checkbox) --- */
  var filterForm = document.getElementById('zy-filter-form');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) {
        filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
      }
    });
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(filterForm));
      var url = new URL(window.location.href.split('?')[0]);
      params.forEach(function (v, k) { if (v) url.searchParams.append(k, v); });
      window.location.href = url.toString();
    });
  }

  /* --- Load more --- */
  var loadMoreBtn = root.querySelector('[data-zy-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return;
      loadMoreBtn.disabled = true;
      /* Presentational-only loading state — reuses the existing
         .zy-btn[data-loading="true"] spinner treatment from
         zy-design-system.css, no new CSS invented. */
      loadMoreBtn.dataset.loading = 'true';
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-zy-grid]');
          var newLoadMore = doc.querySelector('[data-zy-load-more]');
          var grid = root.querySelector('[data-zy-grid]');
          if (newGrid && grid) {
            while (newGrid.firstChild) { grid.appendChild(newGrid.firstChild); }
          }
          if (newLoadMore) {
            loadMoreBtn.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.dataset.loading = 'false';
          } else {
            loadMoreBtn.remove();
          }
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.dataset.loading = 'false';
        });
    });
  }
})();
